function CenterLoading() {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="flex flex-col items-center space-y-6 p-8">
        <div className="space-y-2 text-center">
          <div className="animate-pulse text-2xl font-semibold text-slate-800">
            Initializing Copicake...
          </div>
          <div className="animate-pulse text-sm text-slate-500 delay-150">
            Setting up your creative workspace
          </div>
        </div>

        <div className="flex space-x-1">
          <div className="h-2 w-2 animate-bounce rounded-full bg-blue-500"></div>
          <div
            className="h-2 w-2 animate-bounce rounded-full bg-blue-500"
            style={{ animationDelay: "0.1s" }}
          ></div>
          <div
            className="h-2 w-2 animate-bounce rounded-full bg-blue-500"
            style={{ animationDelay: "0.2s" }}
          ></div>
        </div>
      </div>
    </div>
  );
}

export default CenterLoading;
